import OwnerModel from '../owner/owner-model';
import PersonalinfoModel from '../personalinfo/personalinfo-model';

export default class DivisionModel {
    id: number;
    name: string;
    description: string;
    status: string;
    location: string;
    owner: any;
    ownerCaption: string;
    parent: any;
    parentCaption: string;
    personalinfo: any;
    
    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        this.location = datarow.location;
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        let parent= datarow.parent?.data? new DivisionModel(datarow.parent?.data) : datarow.parent;
        this.parent= parent?.id;
        this.parentCaption = parent?.name;
        let personalinfo = datarow.personalinfo?.data? new PersonalinfoModel(datarow.personalinfo?.data) : datarow.personalinfo;
        this.personalinfo = personalinfo?.id;
        
    } 

    public static endPoint: string = 'divisions' 
    public static endPointFilterList = () => {
       const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name&filters[owner]=' + owner);
    } 
    public static url: string = '/division';
    public static caption: string = 'Division';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        location: '',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),       
        parent: null,
        parentCaption: '',
        personalinfo: null,
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]

}